import * as React from "react";

interface Props {
  size?: number;
  color?: string;
}

const ArrowDownIconV1 = ({ size = 18, color = "currentColor" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 5v14" />
    <path d="M19 12l-7 7-7-7" />
  </svg>
);

export default ArrowDownIconV1;
